<template>
	<div v-click-outside="onClickOutside">
		<div>
			<label class="uk-width-1-1 uk-position-relative">
				<input @click="toggleDropdown"
					   readonly class="uk-form-small uk-input uk-width-1-1 uk-text-medium"
					   :placeholder="getFilterLabel(filterIndex)"
					   :value="getSelectedText">
				<span uk-icon="chevron-down" :class="{ 'uk-text-link uk-icon-rotate': isDropdownOpen }"
					  class="uk-position-absolute uk-position-center-right uk-margin-xsmall-right uk-icon"></span>
			</label>
		</div>
		<div class="uk-position-relative">
			<div class="uk-width-1-1 uk-dropdown uk-dropdown-scroll"
				 v-if="isDropdownOpen">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
    import vClickOutside from "v-click-outside";

	export default {
        name: "Dropdown-checkboxes",
		props: [
			'activeFilters', 'filterIndex', 'filterId'
		],
		directives: {
			clickOutside: vClickOutside.directive
		},
		data() {
			return {
				isDropdownOpen: false
			}
		},
		computed: {
			getSelectedText() {
				if (this.activeFilters && this.activeFilters[this.filterIndex] && this.activeFilters[this.filterIndex].length) {
					return this.activeFilters[this.filterIndex].length + ' ' + this.$t('filters.selected');
				}
				return null;
			}
		},
		methods: {
			onClickOutside() {
				this.isDropdownOpen = false
			},
			toggleDropdown() {
				this.isDropdownOpen = !this.isDropdownOpen
			},
            getFilterLabel(filterIndex) {
                // Try to get translation for this specific filter
                const translation = this.$t('filters.' + filterIndex);
                
                // If translation is the same as the key, it means it's not found
                if (translation === 'filters.' + filterIndex) {
                    // Fallback to a more readable format
                    return filterIndex.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                }
                
                return translation;
            }
		},
    }
</script>

<style lang="scss">
	//.uk-dropdown {
	//	display: block;
	//}
</style>
